import { Theme } from '@mui/material/styles'

const useStyles = {
  moveFolderCurrentLocationContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(3),
  }),
  moveFolderNewLocationContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.info.shades['4p'],
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  }),
  backdrop: (theme: Theme) => ({
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0,0,0,0.8)',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  }),
  backdropSearchContainer: (theme: Theme) => ({ width: `calc(100% - ${theme.spacing(8)})`, marginTop: theme.spacing(24), maxWidth: '930px' }),
  backdropCloseIconButton: (theme: Theme) => ({ position: 'absolute', right: 0, top: 0, color: theme.palette.common.white }),
  backdropCloseIcon: { fontSize: '60px' },
}

export default useStyles
